/* © Facilogi. See LICENSE file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
// import { Dictionary } from "App/Contracts";
import Columns from "App/UseCases/Columns";
// import Fields from "Shared/UseCases/Choices/Fields";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    /* To avoid an issue with $t being empty because it has yet to be injected to Ioc because if
       we put this instantiation at the module level here, it will get executed during
       node module importation step, which is before we inject the actual $t() implementation into
       our Ioc (Through Web/Main.ts), so we wrap it in a funtion. */
    if( sort === undefined )
        sort = new Column( "CreatedAt", $t( "CUSTOMERS_columnCreated" ), "dateTime" );

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            new Column( "Company", $t( "CUSTOMERS_columnCompany" ) ),
            new Column( "Email", $t( "CUSTOMERS_columnEmail" ) ),
            new Column( "Name", $t( "CUSTOMERS_columnName" ) ),
            new Column( "Address", $t( "CUSTOMERS_columnAddress" ) ),
            new Column( "Country", $t( "CUSTOMERS_columnCountry" ) ),
            GetDefaultSort()
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "Customers", getDefault() );
}

// function GetMapping(): Dictionary<string> {
//     return { ...Fields.GetMapping() };
// }

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "Customers", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    // GetMapping,
    Toggle
};
